import { createSlice } from "@reduxjs/toolkit";

export const applicationSlice = createSlice({
    name: 'applications',
    initialState: [],
    reducers: {
        emptyApplications: state => {
            return []
        },
        setApplications: (state, action) => {
            if (Array.isArray(action?.payload)) {
                return action.payload
            }
        },
        addApplication: (state, action) => {
            return [...state, action.payload]
        },
        updateApplication: (state, action) => {
            const foundedIndex = state.findIndex((a) => Number(a.id) === Number(action.payload?.id));
            if (foundedIndex !== -1) {
                state[foundedIndex] = { ...state[foundedIndex], ...action.payload };
                return state;
            } else {
                throw new Error('ProtocolApplication not found');
            }
        },
        removeApplication: (state, action) => {
            return state.filter(app => Number(app?.id) !== Number(action.payload?.id));
        }
    }
});

export const {
    emptyApplications,
    setApplications,
    addApplication,
    updateApplication,
    removeApplication
} = applicationSlice.actions;

export default applicationSlice.reducer
